import { useState } from 'react';
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { ActionItemFormData, ActionItemStatus } from '../../types/actionItems';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

interface ActionItemFormProps {
  initialData?: Partial<ActionItemFormData>;
  onSubmit: (data: ActionItemFormData) => Promise<void>;
  onCancel?: () => void;
  isLoading?: boolean;
}

export function ActionItemForm({ 
  initialData, 
  onSubmit, 
  onCancel,
  isLoading 
}: ActionItemFormProps) {
  const [formData, setFormData] = useState<ActionItemFormData>({
    title: initialData?.title || '',
    description: initialData?.description || '',
    due_date: initialData?.due_date || null,
    status: initialData?.status || 'todo'
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Ensure due_date is null if empty
    const submissionData = {
      ...formData,
      due_date: formData.due_date || null
    };
    
    await onSubmit(submissionData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <Input
          placeholder="Title"
          value={formData.title}
          onChange={(e) => setFormData({ ...formData, title: e.target.value })}
          required
        />
      </div>
      
      <div>
        <Textarea
          placeholder="Description"
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          required
        />
      </div>
      
      <div>
        <Input
          type="date"
          value={formData.due_date || ''}
          onChange={(e) => setFormData({ ...formData, due_date: e.target.value || null })}
        />
      </div>
      
      <div>
        <Select
          value={formData.status}
          onValueChange={(value: ActionItemStatus) => 
            setFormData({ ...formData, status: value })
          }
        >
          <SelectTrigger>
            <SelectValue placeholder="Select status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="todo">To Do</SelectItem>
            <SelectItem value="in_progress">In Progress</SelectItem>
            <SelectItem value="on_hold">On Hold</SelectItem>
            <SelectItem value="done">Done</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="flex justify-end gap-2">
        {onCancel && (
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
        )}
        <Button type="submit" disabled={isLoading}>
          {isLoading ? 'Saving...' : 'Save'}
        </Button>
      </div>
    </form>
  );
}